import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import TabGroup, {
    IndividualTabPropsCustom,
    TabColorProps
} from "@/components/wpl/tab-group/src";
import { Row } from "@/libraries/wpl/foundations/src";

import {
    Notifications,
    AssignAndPrioritize,
    CaptureAndTrack,
    TrackIssues
} from "./content";

const tabStyles: TabColorProps = {
    defaultBG: "n0",
    defaultText: "n900",
    hoverBG: "n0",
    hoverText: "n900",
    activeBG: "b50",
    activeText: "n900"
};

const tabCustomStyles = css({
    "marginBlockStart": "40px",
    "marginBlockEnd": "60px",

    '.tab-group .tab-group-inner button[aria-selected="false"]': {
        color: "#6b778c"
    },

    ".tab-group .tab-group-inner": {
        marginBlockEnd: "20px"
    },

    ".simple-image-text-side-tabs": {
        padding: 0
    },

    ".tab-group .tab-group-inner button": {
        "border": "1px solid transparent",
        "fontSize": "0.875rem",
        "@media (min-width: 1024px)": {
            fontSize: "1.25rem"
        }
    },

    ".tab-group .tab-group-inner button:hover": {
        border: "1px solid #deebff"
    },

    ".tab-group .tab-panel h2": {
        "color": "#253858",
        "fontSize": "1.5rem",

        "@media (min-width: 768px)": {
            fontSize: "2.25rem"
        }
    }
});

const tabSectionTitleStyles = css({
    "textAlign": "center",
    "fontSize": "1.5rem",
    "marginBlockEnd": "40px",
    "fontWeight": "500",
    "color": "#253858",

    "@media(min-width: 768px)": {
        fontSize: "2.25rem"
    }
});

const Tabs = () => {
    const intl = useIntl();
    const tabs: IndividualTabPropsCustom[] = [
        {
            textLabel: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.paidLpJswTracker.tabButton.captureAndTrack",
                defaultMessage: "Capture & Track"
            }),
            id: "capture-and-track",
            component: CaptureAndTrack()
        },
        {
            textLabel: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.paidLpJswTracker.tabButton.assignAndPrioritize",
                defaultMessage: "Assign & prioritize"
            }),
            id: "assign-and-prioritze",
            component: AssignAndPrioritize()
        },
        {
            textLabel: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.paidLpJswTracker.tabButton.trackIssues",
                defaultMessage: "Track issues"
            }),
            id: "track-issues",
            component: TrackIssues()
        },
        {
            textLabel: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.paidLpJswTracker.tabButton.notifications",
                defaultMessage: "Notifications"
            }),
            id: "notifications",
            component: Notifications()
        }
    ];

    return (
        <div css={tabCustomStyles}>
            <Row layout="12">
                <h2 css={tabSectionTitleStyles}>
                    {intl.formatMessage({
                        id: "JiraSoftwarePageTemplate.paidLpJswTracker.tabSectionTitle.quicklyCapture",
                        defaultMessage:
                            "Quickly capture, assign and prioritize bugs with Jira Software"
                    })}
                </h2>
            </Row>
            <TabGroup
                tabContentType="custom"
                tabs={tabs}
                id="tabs"
                label="tabs"
                colors={tabStyles}
            />
        </div>
    );
};

export default Tabs;
